export default function VectorImage(props: any) {
  return <img src={props.source} {...props} />;
}
